module.exports = __webpack_public_path__ + "static/media/moveisfelber.8f2edcbc.webp";